export const getDriveTypeFix = driveType => {
    return (driveType && driveType.length>0) ? `/${driveType}` : ''
}